export default __webpack_public_path__ + "static/media/jcb.a4984db7.svg";